import { memo } from "react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const CTASectionComponent = () => {
  const navigate = useNavigate();

  const handleStartAssessment = () => {
    // Navigate to the assessment page
    navigate("/assessment");
  };

  return (
    <section className="py-12 sm:py-20 bg-[#0f2d69] relative overflow-hidden">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmYiIHN0cm9rZS13aWR0aD0iMC41IiBzdHJva2Utb3BhY2l0eT0iMC4xIi8+PC9zdmc+')] opacity-20" />
      </div>
      
      <div className="container mx-auto max-w-4xl px-4 text-center relative z-10">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4 sm:mb-6">
          Ready to Measure Your AI Maturity?
        </h2>
        <p className="text-base sm:text-lg text-white/80 mb-6 sm:mb-8 max-w-2xl mx-auto">
          Join leading organizations in benchmarking your AI capabilities and get actionable insights for improvement.
        </p>
        <Button 
          onClick={handleStartAssessment}
          className="w-full sm:w-auto h-12 px-6 sm:px-8 text-base sm:text-lg bg-white text-[#0f2d69] hover:bg-white/90 transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl"
        >
          Start Your Assessment
          <ArrowRight className="ml-2 h-5 w-5" />
        </Button>
      </div>
    </section>
  );
};

const CTASection = memo(CTASectionComponent);
export default CTASection;
